import { Monitor, Moon, Sun } from 'lucide-react'
import { nextThemePreference, useTheme, type ThemePreference } from '../lib/theme'

/**
 * Header theme toggle. Click cycles Light, Dark, System (follow your device);
 * each step is an explicit, persisted choice (PR 12, D7: it used to flip only
 * light and dark, so "System" could never be chosen again). The three icons
 * cross-fade/rotate for a small micro-interaction.
 */
const THEME_NAMES: Record<ThemePreference, string> = {
  light: 'Light',
  dark: 'Dark',
  system: 'System (follows your device)',
}

export default function ThemeToggle() {
  const { preference, toggle } = useTheme()
  const next = nextThemePreference(preference)
  const title = `Theme: ${THEME_NAMES[preference]}. Click for ${THEME_NAMES[next].split(' (')[0]}.`
  const icon = (shown: boolean, hidden: string) =>
    `col-start-1 row-start-1 transition-all duration-200 ease-out ${shown ? 'opacity-100 rotate-0 scale-100' : `opacity-0 ${hidden} scale-50`}`
  return (
    <button
      onClick={toggle}
      title={title}
      aria-label={title}
      className="relative h-7 w-7 rounded-md text-ink-muted hover:text-ink hover:bg-surface-3
                 transition-colors duration-150 grid place-items-center"
    >
      <Sun size={15} className={icon(preference === 'light', '-rotate-90')} />
      <Moon size={15} className={icon(preference === 'dark', 'rotate-90')} />
      <Monitor size={15} className={icon(preference === 'system', 'rotate-90')} />
    </button>
  )
}
